import { render } from "./MainGraphics.vue?vue&type=template&id=734f2754"
import script from "./MainGraphics.vue?vue&type=script&lang=js"
export * from "./MainGraphics.vue?vue&type=script&lang=js"

import "./MainGraphics.vue?vue&type=style&index=0&id=734f2754&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__